import { UserProdChatService } from '../services/user-prod-chat.service';
import { UserProdMiteamMeetingsService } from '../services/user-prod-miteam-meetings.service';
import { UserProdMitelOneService } from '../services/user-prod-mitel-one.service';
import { UserProdTelephonyService } from '../services/user-prod-telephony.service';
import { UserProdMiVBService } from '../services/user-prod-mivb.service';
import { UserProdMiCCBService } from '../services/user-prod-miccb.service';
import { ProductLicense } from '../interfaces/product-licenses-interfaces';
import { UserProdMitel5000Service } from '../services/user-prod-mitel-5000.service';
import { UserProdUnifyPhoneService } from '../services/user-prod-unify-phone.service';
import { unifyPhoneCodes, zappaPhoneCodes } from './constants';
import { UserProdZappaPhoneService } from '../services/user-prod-zappa-phone.service';

const MeetingsProduct: ProductLicense = {
    displayName: "users_list.licenseColumn.MiTeam Meetings",
    productCode: "meet",
    formControlId: 'product-meet',
    service: new UserProdMiteamMeetingsService(),
    icon: '../../../../../assets/images/miteam-meetings.svg',
    description: 'integrations.miteam-config.int-description',
    requiresConfiguration: false
};

const chatProduct: ProductLicense = {
    displayName: "product_licenses.chat",
    productCode: "chat",
    formControlId: 'product-chat',
    service: new UserProdChatService(),
    icon: '../../../../../assets/images/mitel-generic-integration-icon.svg',
    description: '',
    requiresConfiguration: false
};

const telephonyProduct: ProductLicense = {
    displayName: "product_licenses.telephony",
    productCode: "telephony",
    formControlId: 'product-telephony',
    service: new UserProdTelephonyService(),
    icon: '../../../../../assets/images/mitel-generic-integration-icon.svg',
    description: '',
    requiresConfiguration: false
};

const mitelOneProduct: ProductLicense = {
    displayName: "product_licenses.mitelOne.name",
    productCode: "mitelOne",
    formControlId: 'product-mitelOne',
    service: new UserProdMitelOneService(),
    icon: '../../../../../assets/images/mitel-one-icon.svg',
    description: '',
    oneTimeSetup: false,
    requiresConfiguration: true,

};

const mivoice5000Product: ProductLicense = {
    displayName: "product_licenses.mivoice5000.name",
    productCode: "mivoice5000",
    formControlId: 'product-mivoice5000',
    service: new UserProdMitel5000Service(),
    icon: '../../../../../assets/images/5000.png',
    description: '',
    oneTimeSetup: false,
    requiresConfiguration: true,
};

const mivbProduct: ProductLicense = {
    displayName: "product_licenses.mivb.name",
    productCode: "mivb",
    formControlId: 'product-mivb',
    service: new UserProdMiVBService(),
    icon: '../../../../../assets/images/mitel-generic-integration-icon.svg',
    description: 'product_licenses.mivb_description',
    oneTimeSetup: false,
    requiresConfiguration: true,
    emailIcon: undefined
    // injectableSubComponentInConfigurationName: ["oneApp"],
};

const MiCCBProduct: ProductLicense = {
    displayName: "users_list.licenseColumn.MiCCB",
    productCode: "miccb",
    formControlId: 'product-miccb',
    service: new UserProdMiCCBService(),
    icon: '../../../../../assets/images/micc.svg',
    description: 'product_licenses.miccb_description',
    requiresConfiguration: true
};

const unifyPhoneProduct: ProductLicense = {
    displayName: 'product_licenses.unifyPhone.name',
    productCode: unifyPhoneCodes.USER_PRODUCT,
    formControlId: 'product-unify-phone',
    service: new UserProdUnifyPhoneService(),
    icon: './../../../../../assets/images/unify-phone.png',
    description: 'product_licenses.unifyPhone.description',
    oneTimeSetup: false,
    requiresConfiguration: false,
    emailIcon: undefined
};

const zappaPhoneProduct: ProductLicense = {
    displayName: 'product_licenses.zappaPhone.name',
    productCode: zappaPhoneCodes.USER_PRODUCT,
    formControlId: 'product-zappa-phone',
    service: new UserProdZappaPhoneService(),
    icon: './../../../../../assets/images/zappa.png',
    description: 'product_licenses.zappaPhone.description',
    oneTimeSetup: false,
    requiresConfiguration: false,
    emailIcon: undefined
};

// NOTE: when creating the UserProductXService, if hasRequiredAccountIntegrations() does any checking further than validating the product is in account product tags,
// product-licenses.service.spec.ts -> getAvailableMitelUserProductList() & getAvailableMitelUserProductListAndFilter() need to be updated to include a spy for it
// otherwise the build will fail intermittently
export const MitelBundledProducts: ProductLicense[] = [
    MeetingsProduct,
    mitelOneProduct,
    mivoice5000Product,
    mivbProduct,
    MiCCBProduct,
    unifyPhoneProduct,
    zappaPhoneProduct
];

export const AllMitelProducts: ProductLicense[] = [
    MeetingsProduct,
    mitelOneProduct,
    chatProduct,
    telephonyProduct,
    mivoice5000Product,
    mivbProduct,
    MiCCBProduct,
    unifyPhoneProduct,
    zappaPhoneProduct
];

export const GwpProducts: ProductLicense[] = [
    mivbProduct
]
